import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { FadeUp } from "../components/Motion";
import SEO from "../components/SEO";

const credentials = [
  { t: "Florida Certified General Contractor", d: "CGC1515086" },
  { t: "Florida Certified Plumbing Contractor", d: "CFC1429871" },
  { t: "Professional Engineer", d: "Florida PE 63780, also Virginia and Puerto Rico" },
  { t: "Service-Disabled Veteran-Owned Small Business", d: "SDVOSB" },
  { t: "Licensed & Insured", d: "Certificates available on request" },
  { t: "Former USACE District Commander", d: "Jacksonville District" },
];

export default function About() {
  return (
    <>
      <SEO title="About BCPeabody | Veteran-Owned Tampa Contractor Since 2006" description="Founded in 2006 by Col. (Ret.) Bob Carpenter, P.E., former USACE Jacksonville District Commander. A Tampa family construction firm." path="/about" />
      <Nav />

      <section className="pt-32 pb-14 bg-cream-light">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.18em] uppercase mb-5 text-copper">About BCPeabody</div>
          <h1 className="font-serif font-medium text-ink tracking-tight leading-[1.05]" style={{ fontSize: "clamp(34px, 5vw, 60px)" }}>
            A Tampa family construction firm, founded by an engineer.
          </h1>
        </div>
      </section>

      <section data-testid="about-intro" className="bg-cream-light pb-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 space-y-6 text-ink/85 leading-relaxed" style={{ fontSize: 17 }}>
          <p>
            Col. (Ret.) Bob Carpenter, P.E., founded BCPeabody in 2006 after 25 years in the Army, retiring as Commander of the U.S. Army Corps of Engineers Jacksonville District. He became a Florida Certified General Contractor in 2008, and by 2014 the firm was running dozens of kitchen, bath and home projects across West Central Florida.
          </p>
          <p>
            Bob leads the firm today as President and CEO and makes its final decisions. His daughter, Kimberly Carpenter, runs project operations and client delivery: estimates, schedules, trades and keeping you informed.
          </p>
        </div>
      </section>

      <section className="bg-cream py-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <FadeUp>
            <p className="font-serif text-ink leading-snug border-l-2 border-copper pl-8" style={{ fontSize: "clamp(22px, 2.6vw, 34px)" }}>
              "We apply the same discipline we use on large federal projects to every custom home, renovation, and recovery engagement we take on."
            </p>
            <div className="mt-6 pl-8 text-[11px] tracking-[0.18em] uppercase text-copper">
              Col. (Ret.) Bob Carpenter, P.E., Founder, President & CEO
            </div>
          </FadeUp>
        </div>
      </section>

      <section data-testid="about-experience" className="bg-cream-light py-20 md:py-24">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <h2 className="font-serif font-medium text-ink tracking-tight mb-6" style={{ fontSize: "clamp(28px, 3.6vw, 40px)" }}>
            Experience that shows up on your project.
          </h2>
          <p className="text-ink/85 leading-relaxed" style={{ fontSize: 17 }}>
            Bob spent his career solving construction problems on paper before they reached the field. Kimberly has spent more than 13 years estimating, purchasing and managing projects, including a remodeling territory with as many as 42 jobs underway at once. For you, that means a line-item price you can follow, a schedule you can plan around, details settled before work starts, and a straight answer when something changes. That holds whether the job is a bathroom, an addition or a new home.
          </p>
        </div>
      </section>

      <section data-testid="about-credentials" className="bg-cream-light py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <h2 className="font-serif font-medium text-ink tracking-tight mb-10" style={{ fontSize: "clamp(28px, 3.6vw, 40px)" }}>
            Licensed, insured and engineer-led.
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-px bg-ink/10">
            {credentials.map((c) => (
              <div key={c.t} className="bg-cream-light p-6 border-l border-copper">
                <h3 className="font-serif text-lg text-ink tracking-tight leading-tight mb-2">{c.t}</h3>
                <p className="text-[11px] tracking-[0.14em] uppercase text-ink/60">{c.d}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-ink/75">
            Looking for our recovery or federal experience? See <Link to="/disaster-recovery" className="text-copper hover:text-copper-deep">Disaster Recovery</Link> and <Link to="/federal" className="text-copper hover:text-copper-deep">Federal Construction & Teaming</Link>.
          </p>
        </div>
      </section>

      <section data-testid="about-cta-band" className="py-20 md:py-24" style={{ backgroundColor: "#2E2923" }}>
        <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center" style={{ color: "#F7F2E9" }}>
          <h2 className="font-serif font-medium tracking-tight mb-6" style={{ fontSize: "clamp(28px, 3.6vw, 40px)", lineHeight: 1.2 }}>
            Planning a project?
          </h2>
          <p className="leading-relaxed mb-10 mx-auto" style={{ fontSize: 17, color: "rgba(247,242,233,0.82)", maxWidth: 620 }}>
            Tell us what you have in mind. We respond within one business day.
          </p>
          <Link to="/contact" data-testid="about-cta-start" className="btn-copper">Start a Project</Link>
        </div>
      </section>

      <Footer />
    </>
  );
}
